import template from '../../../../../ui-formly/partials/form.html'
import FormControllerFactory from '../../../../../ui-formly/controllers/FormControllerFactory'
import fields from './formly'
import server from '../../../../server/index'

partsLocationEdit.vsName = 'partLocationsEdit'
partsLocationEdit.vsNgType = 'directive'

partsLocationEdit.$inject = [server.vsName]
function partsLocationEdit(server) {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model: '=?'
    },
    controller: FormControllerFactory({
      returnState: '^.locations',
      formFields: fields,
      submit: server.partLocationsSave
    }),
    controllerAs: 'ctrl',
    bindToController: true
  }
}

export default partsLocationEdit